import {useState} from "react";
import {DialogTitle, Grid, IconButton} from "@mui/material";
import {Dialog2} from "../../../../../misc/Dialog2";
import CloseIcon from "@mui/icons-material/Close";
import {HardwareGroup} from "../../../../../api/QuoteHardware";
import {ChangesetItem} from "../../../../../api/ProjectChangeset";
import {PopperZIndexProvider} from "../../../../../misc/scroller/PopperZIndexProvider";
import {useProject} from "../../ProjectName";
import {TimelineViewer} from "../../openings/timeline/TimelineViewer";
import {HardwareGroupView} from "./HardwareGroupView";
import {projectLabel} from "../../../../../api/Projects";

export function GroupTimelineView(props: {
    group: HardwareGroup;
    onClose(): void;
}) {
    const project = useProject();
    const [cursor, setCursor] = useState<ChangesetItem>();

    return (
        <Dialog2 open onClose={props.onClose} fullScreen>
            <DialogTitle>
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs>
                        {project && projectLabel(project)}: Hardware Group Timeline: {props.group.name}
                    </Grid>
                    <Grid item>
                        <IconButton onClick={props.onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <TimelineViewer
                hardwareGroups={[props.group.id]}
                value={cursor}
                onChange={setCursor}
            />
            <PopperZIndexProvider value={1400}>
                <HardwareGroupView group={props.group.id} changeset={cursor?.id} />
            </PopperZIndexProvider>
        </Dialog2>
    );
}
